module.exports = __webpack_public_path__ + "6ee7d354a8fb36b07299877e3c710d95.gif";